// Import 3rd-party dependencies
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Import project-specific dependencies
import { ApiService } from '@app/services/api.service';
import { environment } from '@app/environments/environment';

export interface IDisplayAnnouncements {
  id?: string;
  core_id: string;
  announcement: IAnnouncements[];
}

export interface IAnnouncements {
  announcementID: string;
  fullName: string;
  startDate: string;
  endDate: string;
  message: string;
  link: string;
  isTopBanner: boolean;
  directReports: boolean;
  department: string;
  region: string;
  allDXC: boolean;
  createdAt: string;
  isManager: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AnnouncementMaintenanceService extends ApiService {
  private ADMIN_API_URL = environment.DEPS.ADMIN_API.URL;

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  announcementList$ = this.get<IDisplayAnnouncements>(`${this.ADMIN_API_URL}/me/announcements`);

  addAnnouncements(announcement: IDisplayAnnouncements): void {
    this.put(`${this.ADMIN_API_URL}/me/announcements`, announcement).subscribe();
  }
}
